import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Button as CButton } from 'carbon-components-react';

function CTA({
  children,
  className: customClassName,
  title,
  transparent,
  kind,
  ...rest
}) {
  const className = cx('om-cta', {
    [customClassName]: !!customClassName,
    'om-btn--TRANSPARENT': transparent
  });
  return /*#__PURE__*/React.createElement(CButton, _extends({}, rest, {
    className: className,
    kind: kind,
    size: "default"
  }), /*#__PURE__*/React.createElement("span", {
    className: "bx--btn__content",
    title: title
  }, children));
}

CTA.propTypes = {
  /**
   * Specify the content of your CTA
   */
  children: PropTypes.node,

  /**
   * Specify how the button itself should be rendered.
   * Make sure to apply all props to the root node and render children appropriately
   */
  as: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),

  /**
   * Specify an optional className to be added to your CTA
   */
  className: PropTypes.string,

  /**
   * Specify whether the CTA should be disabled, or not
   */
  disabled: PropTypes.bool,

  /**
   * Specify the kind of CTA you want to create
   */
  kind: PropTypes.oneOf(['primary', 'secondary', 'tertiary']).isRequired,

  /**
   * Optionally specify an href for your CTA to become an <a> element
   */
  href: PropTypes.string,

  /**
   * Optional prop to specify the tabIndex of the CTA
   */
  tabIndex: PropTypes.number,

  /**
   * Optional prop to specify the type of the CTA
   */
  type: PropTypes.oneOf(['button', 'reset', 'submit']),

  /**
   * Optional prop to specify the if the background of the CTA
   * should be transparent. Note this only applies to the Secondary and Tertiary
   * kinds.
   */
  transparent: PropTypes.bool,

  /**
   * Optional prop to specify the role of the CTA
   */
  role: PropTypes.string,

  /**
   * Specify the direction of the tooltip for icon-only buttons.
   * Can be either top, right, bottom, or left.
   */
  tooltipPosition: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * Specify the alignment of the tooltip to the icon-only button.
   * Can be one of: start, center, or end.
   */
  tooltipAlignment: PropTypes.oneOf(['start', 'center', 'end'])
};
CTA.defaultProps = {
  disabled: false,
  kind: 'primary',
  tabIndex: 0,
  type: 'button'
};
export default CTA;